export enum ButtonVariant {
  TEXT = 'text', // somente texto
  UNELEVATED = 'unelevated', // bordas levemente arredondadas e sem sombra
  OUTLINED = 'outlined', // apenas bordas levemente arredondadas
  ROUNDED = 'rounded', // bordas arredondadas
  ROUNDED_OUTLINED = 'rounded_outlined', // apenas bordas arredondadas
}
